import React, { useEffect, useRef } from "react";
import { Container } from "react-bootstrap";
import styles from "./styles/styles.module.scss";

import { GoArrowLeft, GoArrowDown } from "react-icons/go";

import Link from "next/link";
import Image from "next/future/image";
import { FormattedMessage, useIntl } from "react-intl";

import { useSelector } from "react-redux";
import { getDataBySlug, handleImageLink } from "@/helpers/functions";

const Index = () => {
  const h1Ref = useRef(null);

  const { locale } = useIntl();

  const { pageData } = useSelector((state) => state.settings);

  const heroData = getDataBySlug(pageData?.sections, "hero");

  useEffect(() => {
    if (!h1Ref.current) return;

    const isDesktop = window.matchMedia("(min-width: 1024px)").matches;
    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    if (!isDesktop || prefersReducedMotion) return;

    let splitInstance = null;
    let mounted = true;

    const initTextAnimation = async () => {
      const [{ default: gsap }, { default: SplitType }] = await Promise.all([
        import("gsap"),
        import("split-type"),
      ]);

      if (!mounted || !h1Ref.current) return;

      splitInstance = new SplitType(h1Ref.current, { types: "chars" });

      gsap.from(splitInstance.chars, {
        opacity: 0,
        y: 40,
        stagger: 0.1,
        duration: 0.8,
        ease: "power3.out",
      });
    };

    if (window.requestIdleCallback) {
      window.requestIdleCallback(initTextAnimation, { timeout: 1200 });
    } else {
      setTimeout(initTextAnimation, 120);
    }

    return () => {
      mounted = false;
      splitInstance?.revert?.();
    };
  }, []);

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (!el) return;

    const offset = 0;

    const top = el.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
      top,
      behavior: "smooth",
    });
  };

  return (
    <div className={styles["hero-section"]}>
      {heroData?.image ? (
        <div className="bg-media" aria-hidden="true">
          <Image
            src={handleImageLink(heroData?.image)}
            alt=""
            fill
            priority
            sizes="100vw"
            quality={65}
          />
        </div>
      ) : null}
      <Container className="align-content-end h-100">
        <div className="content">
          {/* SplitType هيشتغل على الـ h1 ده */}
          <h1 ref={h1Ref}>{heroData?.secTitle?.[locale]}</h1>

          <div className="caption d-flex align-items-center gap-3 justify-content-between">
            <h2
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-delay="400"
            >
              {heroData?.secSubTitle?.[locale]}
            </h2>

            <button
              type="button"
              className="d-flex align-items-center justify-content-center"
              aria-label="Scroll Down"
              onClick={() => scrollToSection("about")}
              data-aos="zoom-in"
              data-aos-duration="1000"
              data-aos-delay="600"
            >
              <GoArrowDown size={25} />
            </button>

            <div
              className="desc"
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-delay="600"
            >
              <p>{heroData?.secDescription?.[locale]}</p>

              <Link href="/contact">
                <a className="btn btn-outline">
                  <FormattedMessage id="request" />
                  <GoArrowLeft size={25} />
                </a>
              </Link>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Index;
